import type { ColorLabel } from "common/constants/colorsOld";
import { getThemeColor } from "common/constants/colorsOld";
import type { HTMLAttributes } from "react";
import cx from "ui/cx";
import styles from "./Circle.module.scss";

interface CircleProps extends HTMLAttributes<HTMLElement> {
  size: number;
  bg?: ColorLabel;
  corners?: boolean;
}

export default function Circle({ size, corners = false, children, bg, className, style }: CircleProps) {
  const backgroundColor = getThemeColor(bg);

  return (
    <div
      className={cx({ styles, wrapper: true, corners }, className)}
      style={{ ...style, backgroundColor, width: size, height: size }}
    >
      {children}
    </div>
  );
}
